<div class="p-6">
  <app-table
    [config]="coreDataTableConfig"
    [data]="coreDataTable"
    [(selectedElements)]="selectedElements"
  ></app-table>

  @if (selectedElements && selectedElements.length  === 1) {
    <div class="pt-4">
      <app-card>
        <div title>Stamdata</div>
        <div class="flex gap-4">
          <div class="w-1/3">
            <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
              {{ 'meteringpoint.customer.title' | translate }}
            </div>
            <app-value-details
              [collection]="customerMasterData"
              [data]="customerData"
            ></app-value-details>
          </div>
          <div class="w-1/3">
            <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
              {{ 'meteringpoint.contact.title' | translate }}
            </div>
            <app-value-details
              [collection]="contactMasterData"
              [data]="selectedElements[0]"
            ></app-value-details>
          </div>
          <div class="w-1/3">
            <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md">
              {{ 'meteringpoint.location.title' | translate }}
            </div>
            <app-value-details
              [collection]="locationMasterData"
              [data]="selectedElements[0]"
            ></app-value-details>
          </div>
        </div>
      </app-card>
    </div>
  }
</div>
